/// <amd-module name="Pipeline/Analytics/Common/ChartHelper/StackedColumnChartDataSelector" />
import { gridLineColor } from "Analytics/Shared/Common/Constants";
import { IPipelineAnalyticsTelemetryService } from "Pipeline/Analytics/Common/Telemetry/PipelineAnalyticsTelemetryService";
import * as TelemetryConstants from "Pipeline/Analytics/Common/Telemetry/TelemetryConstants";
import { IAnalyticsChartProps } from "Pipeline/Analytics/Common/Types";
import { ChartProps, ChartTypesConstants, LabelFormatModes, LegendClickEvent } from "VSS/Features/Charts/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";

export function getStackedColumnChartData(pageContext: IVssPageContext, data: IAnalyticsChartProps): ChartProps {
    return {
        title: data.title,
        pageContext: pageContext,
        chartType: ChartTypesConstants.StackedColumn,
        suppressAnimation: true,
        xAxis: {
            formatAccessibleLabelsUsingAxisCategories: true,
            labelFormatMode: LabelFormatModes.DateTime_DayInMonth,
            labelValues: data.xAxisLabelValues || [],
            min: 0,
            max: data.xAxisLabelValues!.length - 1
        },
        yAxis: {
            labelFormatMode: LabelFormatModes.Linear,
            title: data.yAxisTitle!.toUpperCase(),
            min: 0,
            allowDecimals: false,
            markingsEnabled: false,
            gridLineOptions: {
                enabled: true,
                gridLineColor: gridLineColor
            }
        },
        legend: {
            enabled: false
        },
        legendClick: (clickEvent: LegendClickEvent) => {
            _publishLegendClickTelemetry(pageContext, data.telemetryArea || "");
            return true;
        },
        series: data.series
    } as ChartProps;
}

function _publishLegendClickTelemetry(pageContext: IVssPageContext, area: string): void {
    const telemetryService = pageContext.getService<IPipelineAnalyticsTelemetryService>("IPipelineAnalyticsTelemetryService");
    telemetryService.publishEventWithSingleKey(area, TelemetryConstants.LegendClickCount, 1);
}
